const conf = {
  googleMapToken: process.env.REACT_APP_GOOGLE_MAP_TOKEN,
  // googleMapGeocodingKey: process.env.REACT_APP_GOOGLE_MAP_GEOCODING_TOKEN,
  oauthCredentials: {
    grant_type: process.env.REACT_APP_CLIENT_CREDENTIALS,
    client_id: process.env.REACT_APP_CLIENT_ID,
    client_secret: process.env.REACT_APP_CLIENT_SECRET,
  },
  baseUrl: process.env.REACT_APP_BASE_URL
};

export default conf;



// WEBPACK FOOTER //
// src/conf.js